module.exports = __webpack_public_path__ + "static/media/map-marker.7ff06c2a.svg";